// src/i18nProvider.ts
import polyglotI18nProvider from 'ra-i18n-polyglot';
import frenchMessages from 'ra-language-french';

// messages object if you ever add more locales
const messages: Record<string, any> = {
  fr: frenchMessages,
  // en: englishMessages,
};

const i18nProvider = polyglotI18nProvider(
  locale => messages[locale] || messages.fr,
  'fr' // default locale
);

export default i18nProvider;
